import { CoordinateDTO } from '../api/model/coordinate-dto';

/**
 * Determines the center of a polygonal area by finding the middle between the highest and lowest longitude and latitude each.
 */
export const centerOfArea = (area: Array<CoordinateDTO>): CoordinateDTO => {
    const half = .5;

    if (!area.length) {
        return { longitude: 0, latitude: 0 };
    }

    if (area.length === 1) {
        return { longitude: area[0]?.longitude ?? 0, latitude: area[0]?.latitude ?? 0 };
    }

    const longitudes = area.map(point => point.longitude);
    const latitudes = area.map(point => point.latitude);

    const averageLongitude = (Math.min(...longitudes) + Math.max(...longitudes)) * half;
    const averageLatitude = (Math.min(...latitudes) + Math.max(...latitudes)) * half;

    return { longitude: averageLongitude, latitude: averageLatitude };
};
